<template lang="html">
  <v-container fluid>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <v-card-text>
            <v-container fluid grid-list-md class="grey lighten-4">
              <h2>Os seguintes recursos estão disponíveis em caso de dúvidas:</h2>
              <br>
              <v-layout row wrap>
                <v-flex>
                  <v-card >
                    <v-card-title>Perguntas Frequentes:</v-card-title>
                    <v-card-text>
                      <p>Respostas para as dúvidas mais comuns sobre o sistema e procedimentos realizados pela PRPPG.</p>
                      <a href="#">Perguntas Frequentes</a>         
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <v-card >
                    <v-card-title>Orientações Gerais:</v-card-title>
                    <v-card-text>
                      <p>Está com dúvidas sobre como registrar um projeto de pesquisa? Acesse os arquivos abaixo:</p>
                      <a href="#">Arquivo 1</a>
                      <br>
                      <a href="#">Arquivo 2</a>
                      <br>
                      <a href="#">Arquivo 3</a>
                      <br>
                      <br>
                      <p>Para obter maiores informações sobre os Objetivos de Desenvolvimento Sustentável (ODS), clique nos links abaixo:</p>
                      <a href="https://ods.ufes.br/" target="_blank">UFES - Objetivos de Desenvolvimento Sustentável</a>
                      <br>
                      <a href="http://www.agenda2030.com.br/" target="_blank">Plataforma Agenda 2030</a>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <v-card >
                    <v-card-title>Fale Conosco:</v-card-title>
                    <v-card-text>
                      <p>Sistema de suporte da aplicação, que deve ser utilizado caso não consiga resolver sua dúvida com as orientações gerais ou com as perguntas frequentes.</p>
                      <a href="#">Sistema de Suporte</a>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'ajuda'
  }
</script>



// WEBPACK FOOTER //
// ajuda-pesquisa.vue?0b3f7b99